module.exports = __webpack_public_path__ + "static/media/people.e07f5c19.svg";